import EmaAddPatientComposer from '../leadModalChat/chatComposer/integrations/ema/EmaAddPatientComposer.js';
import FacebookMessengerComposer from '../leadModalChat/chatComposer/FacebookMessengerComposer.js';
import InstagramComposer from '../leadModalChat/chatComposer/InstagramComposer.js';
import NextechAddPatientComposer from '../leadModalChat/chatComposer/integrations/nextech/NextechAddPatientComposer.js';
import FourthDimensionComposer from '../leadModalChat/chatComposer/integrations/4thDimension/FourthDimensionAddPatientComposer.js';
import PatientNowComposer from '../leadModalChat/chatComposer/integrations/patientnow/PatientNowAddPatientComposer.js';
import ReviewLoopComposer from '../leadModalChat/chatComposer/integrations/reviewloop/ReviewLoopComposer.js';
import IntakeQAddLeadComposer from '../leadModalChat/chatComposer/integrations/intakeQ/IntakeQAddLeadComposer.js';
import EnvisionAddLeadComposer from '../leadModalChat/chatComposer/integrations/envision/envisionAddLeadComposer.js';
import FacebookIntegrationConnector from '../../settings/integrationSettings/facebookMessenger/FacebookIntegrationConnector.js';
import NextechPaymentSync from '../leadModalChat/chatComposer/integrations/nextech/NextechPaymentSync.js';
import setQuery from 'lib/setQuery.js';

const coreTypes = [
  {
    type: 'text',
    label: 'Compose SMS',
  },
  {
    type: 'email',
    label: 'Compose Email',
  },
  {
    type: 'call',
    label: 'Compose Call',
  },
  {
    type: 'todo',
    label: 'Create Todo',
    handleClick: () => {
      setQuery({ tab: 'todos' });
      setTimeout(() => {
        setQuery({ creating: 'todo' });
      }, 1);
    },
  },
  {
    type: 'note',
    label: 'Create Note',
    handleClick: () => {
      setQuery({ tab: 'basic' });
      setTimeout(() => {
        setQuery({ creating: 'note' });
      }, 1);
    },
  },
];

/*
 * Integration "type" must match platform_registration.platform_code for proper matching
 * */

const integrationTypes = [
  {
    seq: 1,
    type: 'facebookmessenger',
    label: 'Facebook Messenger',
    integration: true,
    allowOnNonLeads: true,
    visible: true,
    connectorComponent: FacebookIntegrationConnector,
    fields: [''],
    actions: [
      {
        label: 'Send with Facebook Messenger',
        component: FacebookMessengerComposer,
        queryParam: 'messenger',
      },
    ],
  },
  {
    seq: 2,
    type: 'instagram',
    label: 'Instagram',
    integration: true,
    allowOnNonLeads: true,
    visible: true,
    fields: [''],
    actions: [
      {
        label: 'Send with Instagram Messenger',
        component: InstagramComposer,
        queryParam: 'messenger',
      },
    ],
  },
  {
    seq: 20,
    type: 'facebook',
    label: 'Facebook',
    integration: true,
    allowOnNonLeads: false,
    visible: false,
    onboardDescription: 'Connect your Facebook account to manage your Instagram and Messenger messages directly through LeadLoop. Click “Connect” to learn more.',
    connectorComponent: FacebookIntegrationConnector,
  },
  {
    seq: 3,
    type: 'reviewloop',
    label: 'ReviewLoop',
    integration: true,
    visible: true,
    fields: ['authenticationToken'],
    actions: [
      {
        label: 'Send Review Request',
        component: ReviewLoopComposer,
        queryParam: 'request-review',
      },
    ],
  },
  {
    seq: 5,
    type: 'patientnow',
    label: 'PatientNow',
    integration: true,
    visible: true,
    fields: {
      providerProfileId: 'User',
      authenticationPassword: 'Password',
    },
    actions: [
      {
        label: 'Add to PatientNow',
        component: PatientNowComposer,
        queryParam: 'add-lead',
      },
    ],
    sync: {
      type: 'manual',
      dataType: 'lead',
    },
  },
  {
    seq: 4,
    type: '4th-dimension',
    label: '4th Dimension',
    integration: true,
    visible: true,
    fields: ['authenticationId', 'secret'],
    actions: [
      {
        label: 'Add to 4th Dimension',
        component: FourthDimensionComposer,
        queryParam: 'add-lead',
      },
    ],
    sync: {
      type: 'manual',
      dataType: 'lead',
    },
  },
  {
    seq: 5,
    type: 'activecampaign',
    label: 'ActiveCampaign',
    integration: true,
    visible: true,
    allowOnNonLeads: false,
    fields: ['providerProfileId', 'authenticationToken', 'secret'],
    actions: [],
    sync: {
      type: 'scheduled',
      dataType: 'pipeline_lead',
    },
  },
  {
    seq: 6,
    type: 'ema',
    label: 'EMA',
    integration: true,
    visible: true,
    allowOnNonLeads: false,
    fields: {
      providerProfileId: 'URL Prefix',
      authenticationId: 'API User Id',
      authenticationPassword: 'API Password',
    },
    actions: [{ label: 'Add to EMA', component: EmaAddPatientComposer, queryParam: 'add-lead' }],
    sync: {
      type: 'manual',
      dataType: 'lead',
    },
  },
  {
    seq: 7,
    type: 'nextech',
    label: 'Nextech',
    integration: true,
    visible: true,
    allowOnNonLeads: false,
    fields: {
      providerProfileId: 'Application ID',
      authenticationId: 'Group ID',
      emailAddress: 'Username',
      authenticationPassword: 'Password',
    },
    actions: [
      { label: 'Add to Nextech', component: NextechAddPatientComposer, queryParam: 'add-lead' },
      { label: 'Payment sync', component: NextechPaymentSync, queryParam: 'sync-payments', syncCondition: 'nextech' },
    ],
    sync: {
      type: 'manual',
      dataType: 'lead',
    },
  },
  {
    seq: 8,
    type: 'intake-q',
    label: 'IntakeQ',
    integration: true,
    visible: true,
    allowOnNonLeads: false,
    fields: ['authenticationToken'],
    actions: [{ label: 'Add to IntakeQ', component: IntakeQAddLeadComposer, queryParam: 'add-lead' }],
    sync: {
      type: 'manual',
      dataType: 'lead',
    },
  },
  {
    seq: 9,
    type: 'envision',
    label: 'Envision',
    integration: true,
    visible: true,
    allowOnNonLeads: false,
    fields: ['providerProfileId', 'authenticationToken', 'authenticationPassword'],
    actions: [{ label: 'Add to Envision', component: EnvisionAddLeadComposer, queryParam: 'add-lead' }],
    sync: {
      type: 'manual',
      dataType: 'lead',
    },
  },
  {
    seq: 10,
    type: 'whatconverts',
    label: 'What Converts',
    integration: false,
    visible: false,
    allowOnNonLeads: false,
    fields: {
      platformProviderId: 'Account ID',
      providerProfileId: 'Profile ID',
      authenticationId: 'API Token',
      authenticationToken: 'Client Secret',
    },
    actions: [],
  },
  {
    type: 'sitestaffchat',
    label: 'SiteStaff Chat',
    integration: false,
    visible: false,
    allowOnNonLeads: false,
    fields: ['providerProfileId'],
    actions: [],
  },
  {
    type: 'apexchat',
    label: 'Apex Chat',
    integration: false,
    visible: false,
    allowOnNonLeads: false,
    fields: ['providerProfileId'],
    actions: [],
  },
  {
    type: 'constantcontact',
    label: 'Constant Contact',
    integration: false,
    visible: false,
    allowOnNonLeads: false,
    fields: [],
    actions: [],
    oauth: true,
  },
];

export const getCoreComposerTypes = () => coreTypes;
export const getIntegrationComposerTypes = () => integrationTypes;
export const getAllComposerTypes = () => [...coreTypes, ...integrationTypes];
